import React, { useEffect, useState } from 'react'
import { CFormSelect, CFormCheck } from '@coreui/react'
import '../content.scss'
import '../../../../scss/style.scss'
import CloseIcon from '../../../../assets/close-icon.svg'
import Select from 'react-select'
import { isEmpty } from 'lodash'
import CustomMultiSelect from 'src/components/customMultiSelect/customMultiSelect'

const filterSummaryTagStyles = {
  fontSize: '12px',
  padding: '.25ch .5ch',
  backgroundColor: 'white',
  marginLeft: '4px',
  fontWeight: '600',
  lineHeight: '12px',
  borderRadius: '20px',
  color: 'black',
}

const AutoGeneratedPlaylist = ({
  payload,
  setPayload,
  categoryMasterData,
  subCategoryMasterData,
  subscriptionMasterData,
  ppvMasterData,
  artistData,
  customMetadataMaster,
}) => {
  let valueOptionsObj = {
    category: categoryMasterData,
    sub_categories: subCategoryMasterData,
    active_subscription: subscriptionMasterData,
    active_ppv: ppvMasterData,
    artists: artistData,
  }
  const [fieldFilters, setFieldFilters] = useState([
    {
      key: '',
      name: '',
      type: '',
      filter_type: 'AND',
      operator: 'eq',
      values: [],
    },
  ])

  const [filterSummary, setFilterSummary] = useState([])

  const [valueFilterArr, setValueFilterArr] = useState([
    {
      selectedValue: [],
      optionsData: [],
    },
  ])
  const [customDefinedOptions, setCustomDefinedOptions] = useState([])

  const getValueTypeName = (key, id) => {
    if (!valueOptionsObj[key]) {
      return ''
    }
    let nameObj = valueOptionsObj[key].find((info) => info?._id === id)
    if (nameObj) {
      return nameObj.name
    }
    return ''
  }

  useEffect(() => {
    if (!isEmpty(fieldFilters)) {
      let tempSummArr = []
      for (let i = 0; i < fieldFilters.length; i++) {
        const fieldObj = fieldFilters[i]
        // debugger
        if (fieldObj.key && !isEmpty(fieldObj.values)) {
          fieldObj.values.forEach((val) => {
            return tempSummArr.push({
              value: val,
              key: fieldObj.key,
              name:
                fieldObj.type === 'system_defined'
                  ? `${fieldObj.name} : ${getValueTypeName(fieldObj.key, val)}`
                  : `${fieldObj.name} : ${val}`,
            })
          })
        }
      }
      setFilterSummary([...tempSummArr])
    }
  }, [
    fieldFilters,
    categoryMasterData,
    subCategoryMasterData,
    subscriptionMasterData,
    ppvMasterData,
    artistData,
    customMetadataMaster,
  ])

  useEffect(() => {
    if (!isEmpty(payload)) {
      setFieldFilters(payload)
      let tempValueArr = []
      for (let i = 0; i < payload.length; i++) {
        const payloadObj = payload[i]
        let valueObj = {
          selectedValue: [],
          optionsData: [],
        }
        if (payloadObj.type === 'system_defined') {
          if (!isEmpty(valueOptionsObj[payloadObj?.key])) {
            valueObj.optionsData = valueOptionsObj[payloadObj?.key].map((info) => ({
              _id: info?._id,
              name: info?.name,
            }))
            valueObj.selectedValue = payloadObj.values.map((info) => ({
              _id: info,
              name: getValueTypeName(payloadObj.key, info),
            }))
          }
        } else if (!isEmpty(customMetadataMaster)) {
          let customObj = customMetadataMaster.find((info) => info._id === payloadObj.key)
          if (customObj) {
            valueObj.optionsData = customObj?.range_values.map((info) => ({
              _id: info,
              name: info,
            }))
            valueObj.selectedValue = payloadObj.values.map((info) => ({
              _id: info,
              name: info,
            }))
          }
        }

        tempValueArr.push(valueObj)

        // if (selectedOption.type === 'system_defined') {
        //   tempValue[idx].optionsData = valueOptionsObj[selectedOption.value].map((info) => ({
        //     _id: info?._id,
        //     name: info?.name,
        //   }))
        // } else {
        //   let customObj = customMetadataMaster.find((info) => info._id === selectedOption.value)
        //   if (customObj) {
        //     tempValue[idx].optionsData = customObj?.range_values.map((info) => ({
        //       _id: info,
        //       name: info,
        //     }))
        //   }
      }
      setValueFilterArr([...tempValueArr])
    }
  }, [
    payload,
    categoryMasterData,
    subCategoryMasterData,
    subscriptionMasterData,
    ppvMasterData,
    artistData,
    customMetadataMaster,
  ])

  useEffect(() => {
    if (!isEmpty(customMetadataMaster)) {
      setCustomDefinedOptions(
        customMetadataMaster.map((customItem) => ({
          value: customItem._id,
          label: customItem.name,
          type: 'custom_defined',
        })),
      )
    }
  }, [customMetadataMaster])

  const handleAndOrFilter = (idx, value) => {
    console.log('handleAndOrFilter', idx, value)
    let tempFieldFilters = fieldFilters
    tempFieldFilters[idx] = { ...tempFieldFilters[idx], filter_type: value }
    setFieldFilters([...tempFieldFilters])
    setPayload([...tempFieldFilters])
  }

  const onChangeOperator = (idx, value) => {
    console.log('handleAndOrFilter', idx, value)
    let tempFieldFilters = fieldFilters
    tempFieldFilters[idx] = { ...tempFieldFilters[idx], operator: value }
    setFieldFilters([...tempFieldFilters])
    setPayload([...tempFieldFilters])
  }

  const handleRemoveFilter = (idx) => {
    let tempFieldFilters = fieldFilters
    let tempValueFilter = valueFilterArr
    tempFieldFilters.splice(idx, 1)
    tempValueFilter.splice(idx, 1)
    setFieldFilters([...tempFieldFilters])
    setPayload([...tempFieldFilters])
    setValueFilterArr([...tempValueFilter])
  }
  // add field filters
  const addFieldFilters = () => {
    setFieldFilters((prev) => [
      ...prev,
      {
        key: '',
        name: '',
        type: '',
        filter_type: 'AND',
        operator: 'eq',
        values: [],
      },
    ])
    setValueFilterArr((prev) => [
      ...prev,
      {
        selectedValue: [],
        optionsData: [],
      },
    ])
  }

  const systemDefinedOptions = [
    { value: 'category', label: 'Category', type: 'system_defined', isdisabled: true },
    { value: 'sub_categories', label: 'Sub-Category', type: 'system_defined', disabled: false },
    {
      value: 'active_subscription',
      label: 'Subscription',
      type: 'system_defined',
      disabled: false,
    },
    { value: 'active_ppv', label: 'PPV', type: 'system_defined', disabled: false },
    { value: 'artists', label: 'Artist', type: 'system_defined', disabled: false },
  ]

  const groupedOptions = [
    {
      label: 'System Defined',
      options: systemDefinedOptions,
    },
    {
      label: 'Custom Defined',
      options: customDefinedOptions,
    },
  ]

  const handleGroupedChange = (selectedOption, idx) => {
    let tempFieldFilters = fieldFilters
    tempFieldFilters[idx] = {
      ...tempFieldFilters[idx],
      key: selectedOption.value,
      name: selectedOption.label,
      type: selectedOption.type,
      values: [],
    }
    setFieldFilters([...tempFieldFilters])
    setPayload([...tempFieldFilters])

    let tempValue = valueFilterArr
    if (selectedOption.type === 'system_defined') {
      tempValue[idx].optionsData = valueOptionsObj[selectedOption.value].map((info) => ({
        _id: info?._id,
        name: info?.name,
      }))
    } else {
      let customObj = customMetadataMaster.find((info) => info._id === selectedOption.value)
      if (customObj) {
        tempValue[idx].optionsData = customObj?.range_values.map((info) => ({
          _id: info,
          name: info,
        }))
      }
    }
    tempValue[idx].selectedValue = []
    setValueFilterArr([...tempValue])
  }
  const handleValueFilterChange = (value, idx) => {
    let tempFieldFilters = fieldFilters
    tempFieldFilters[idx] = {
      ...tempFieldFilters[idx],
      values: value.map((ele) => ele._id),
    }
    setFieldFilters([...tempFieldFilters])
    setPayload([...tempFieldFilters])

    let tempValue = valueFilterArr
    tempValue[idx].selectedValue = value
    setValueFilterArr([...tempValue])
  }

  const checkFieldDisabled = (value) => {
    let fieldIndex = fieldFilters.map((info) => info.key).indexOf(value)
    return fieldIndex > -1
  }

  const handleRemoveFilterSummary = (key, value) => {
    let tempFieldFilters = fieldFilters
    let tempValueArr = valueFilterArr
    let index = tempFieldFilters.findIndex((info) => info.key === key)

    if (index > -1) {
      tempFieldFilters[index] = {
        ...tempFieldFilters[index],
        values: tempFieldFilters[index].values.filter((ele) => ele !== value),
      }
      tempValueArr[index] = {
        ...tempValueArr[index],
        selectedValue: tempValueArr[index].selectedValue.filter((ele) => ele._id !== value),
      }
      setFieldFilters([...tempFieldFilters])
      setPayload([...tempFieldFilters])
      setValueFilterArr([...tempValueArr])
    }
  }

  return (
    <div>
      <div
        className="d-flex justify-content-center"
        style={{
          padding: '1.42vw 0vw 0',
          margin: '0 auto 2vh',
          width: '100%',
          visibility: 'hidden',
        }}
      >
        <h6 style={{ marginRight: 'auto', fontSize: '14px' }}>0 Contents Selected</h6>
      </div>
      <div style={{ outline: '2px solid transparent' }} className="d-flex justify-content-between">
        <div style={{ outline: '2px solid transparent', width: '68.64%' }}>
          <div
            className="d-flex justify-content-between align-items-center px-4 bg-black text-white text-center rounded-1"
            style={{
              width: '100%',
              fontSize: '12px',
              padding: '2px 0',
              marginBottom: '12px',
            }}
          >
            <p style={{ marginBlockEnd: '0', width: '22%' }}>Field</p>
            <p style={{ marginBlockEnd: '0', width: '10%' }}>Operator</p>
            <p style={{ marginBlockEnd: '0', width: '22%' }}>Value</p>
            <p style={{ marginBlockEnd: '0', width: '15.75%' }}>Filter Type</p>
            <div style={{ width: '2.5%' }} />
          </div>
          <div
            style={{
              height: '374px',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
            className="custom-scrollbar-vertical"
          >
            <div>
              {fieldFilters.map((fieldFilter, idx) => {
                let groupedValue = {
                  value: fieldFilter.key,
                  label: fieldFilter.name,
                  type: fieldFilter.type,
                }
                return (
                  <div
                    className="d-flex justify-content-between items-center mb-3 px-4 py-1 rounded-2"
                    style={{ backgroundColor: '#d9d9d9' }}
                    key={idx}
                  >
                    <div style={{ width: '22%' }}>
                      <Select
                        className="w-100"
                        value={groupedValue}
                        onChange={(value) => handleGroupedChange(value, idx)}
                        options={groupedOptions}
                        isOptionDisabled={(option) => {
                          let result = checkFieldDisabled(option.value)
                          return result
                        }}
                      />
                    </div>

                    <div style={{ width: '10%', fontWeight: '600' }}>
                      <CFormSelect
                        size="sm"
                        aria-label="Operator Filter Selector"
                        value={fieldFilter.operator}
                        onChange={(e) => onChangeOperator(idx, e.target.value)}
                      >
                        <option value={'eq'}>{'='}</option>
                        <option value={'not'}>{'!='}</option>
                      </CFormSelect>
                    </div>
                    <div style={{ width: '22%', fontWeight: '600' }} className="">
                      <CustomMultiSelect
                        selectedValue={valueFilterArr[idx]?.selectedValue}
                        optionsData={valueFilterArr[idx]?.optionsData}
                        onChange={(value) => handleValueFilterChange(value, idx)}
                        labelKey="name"
                      />
                    </div>

                    <div
                      className="d-flex justify-content-center align-items-center rounded-1 overflow-hidden"
                      style={{
                        border: fieldFilters.length - 1 !== idx ? '0.5px solid #707070' : '',
                        width: '15.75%',
                      }}
                    >
                      {fieldFilters.length - 1 !== idx && (
                        <>
                          <CFormCheck
                            className="filter-type-and-or-cformcheck"
                            type="radio"
                            id={`AND${idx}`}
                            label="AND"
                            value="AND"
                            checked={fieldFilter.filter_type === 'AND'}
                            onClick={() => handleAndOrFilter(idx, 'AND')}
                          />
                          <CFormCheck
                            className="filter-type-and-or-cformcheck"
                            type="radio"
                            id={`OR${idx}`}
                            label="OR"
                            value="OR"
                            checked={fieldFilter.filter_type === 'OR'}
                            onClick={() => handleAndOrFilter(idx, 'OR')}
                          />
                        </>
                      )}
                    </div>
                    <div style={{ width: '2.5%' }}>
                      {fieldFilters.length > 1 && (
                        <img
                          src={CloseIcon}
                          className="cursor-pointer"
                          alt="closeicon"
                          onClick={() => handleRemoveFilter(idx)}
                        />
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
            <div
              className="d-flex justify-content-center align-items-center mb-3 px-4 py-1 rounded-2"
              style={{ backgroundColor: '#d9d9d9', height: '40px' }}
            >
              <h6
                className="bg-black text-white w-25 text-center h-100 d-flex justify-content-center align-items-center rounded-2"
                role={'button'}
                style={{ marginBlockEnd: '0' }}
                onClick={() => addFieldFilters()}
              >
                ADD FILTER
              </h6>
            </div>
          </div>
        </div>
        <div style={{ outline: '2px solid transparent', width: '26.5%' }}>
          <div
            className="d-flex justify-content-between align-items-center bg-black text-white text-center rounded-1"
            style={{ fontSize: '12px', padding: '2px 0', marginBottom: '12px' }}
          >
            <p style={{ marginBlockEnd: '0', width: '100%' }}>Filter Summary</p>
          </div>
          <div
            style={{
              padding: '.65vw 1vw',
              height: '374px',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
            className="custom-scrollbar-vertical border rounded-1"
          >
            {/* <p
            style={{
              borderBottom: '1px solid #707070',
              paddingBottom: 'max(8px, .6vw)',
              marginBlockEnd: 'max(10px, .7vw)',
            }}
          >
            {"'"}126{"'"} results
          </p> */}
            <div className="">
              {filterSummary.map((info, index) => (
                <span
                  className=" text-white bg-black rounded-4 d-inline-flex justify-content-center align-items-center ml-1"
                  style={{ fontSize: '12px', padding: '.25ch 1ch' }}
                  key={index}
                >
                  {info.name}
                  <span
                    onClick={() => handleRemoveFilterSummary(info.key, info.value)}
                    style={filterSummaryTagStyles}
                    className="cursor-pointer"
                  >
                    X
                  </span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AutoGeneratedPlaylist
